<template>
  <div class="legal-modal">

    <div class="age-circle" v-text="legalAgePopupAgeLabel + '+'" v-if="legalAgePopupAgeLabel"></div>
    <h1 class="title" v-text="legalAgePopupTitle" v-if="legalAgePopupTitle"></h1>

    <div class="content" v-html="legalText" v-if="legalText"></div>
    <div class="buttons">
      <ion-button class="note-button negative" color="primary" fill="outline" shape="round" @click="no">{{ noLabel
      }}</ion-button>
      <ion-button class="note-button remove" fill="solid" shape="round" @click="yes">{{ yesLabel }}</ion-button>
    </div>

  </div>



</template>

<script setup>

import {
  IonButton,
  IonIcon,
  modalController,

} from "@ionic/vue";


</script>
<script>
export default {
  props: [],
  computed: {
    legalAgePopupTitle() {
      if (this.company && this.company.legalAgePopupTitle) {
        return this.services.translations.translation2Text(this.company.legalAgePopupTitle)
      }
      return null
    },
    legalAgePopupAgeLabel() {
      if (this.company && this.company.legalAgePopupAgeLabel) {
        return this.services.translations.translation2Text(this.company.legalAgePopupAgeLabel)
      }
      return null
    },
    noLabel() {
      if (this.company && this.company.legalAgePopupNegativeButtonLabel) {
        return this.services.translations.translation2Text(this.company.legalAgePopupNegativeButtonLabel)
      }
      return this.$t('no-label')
    },
    yesLabel() {
      if (this.company && this.company.legalAgePopupPositiveButtonLabel) {
        return this.services.translations.translation2Text(this.company.legalAgePopupPositiveButtonLabel)
      }
      return this.$t('yes-label')
    },
    legalText() {
      if (this.company && this.company.enableLegalAgePopup && this.company.legalAgePopupContent) {
        let text = this.services.translations.translation2Text(this.company.legalAgePopupContent)
        console.log('text', text)
        return text.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }
      return null

    }
  },
  data() {
    return {
    }
  },

  methods: {
    no() {

      modalController.dismiss(false)
    },
    yes() {
      modalController.dismiss(true)
    },
  },
}
</script>
<style scoped>
.legal-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: white;
  padding: 2rem 3rem;
}

.legal-modal .content {
  /* flex:1; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 300;
  text-align: center;
}

.legal-modal .content::first-letter{
  text-transform: capitalize;
}

.legal-modal .buttons {
  display: flex;
  align-items: center;
  justify-content: center;
}

.legal-modal .buttons ion-button {
  margin: 0 1rem;

}

.legal-modal .title {
  margin-bottom: 1.7rem;
  font-weight: 400;
  text-transform: capitalize;
}
.legal-modal .age-circle {
  border: 1.5px solid var(--ion-color-primary);;
  border-radius: 3rem;
  min-height: 5rem;
  width: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ion-color-primary);
  font-size: 1.7rem;
  font-weight: 500;
  
}
</style>
<style>
@media (min-width: 768px) {
  ion-modal.legal-modal::part(content) {
    height: 60%;
    border-radius: 0.5rem;
  }
}
</style>